<template>
  <div>
    <div v-if="!is_sent_file">
      <div>
        <p><b>File</b></p>
        <div class="is-flex is-align-items-center">
          <input class="padding_0" style="border-radius: 0;" type="file" accept=".pdf, .doc, .docx" @change="getFile">
          <div class="horizontal_space"></div>
          <p class="bold" v-if="file">{{file.name}}</p>
        </div>
      </div>
      <div class="vertical_space"></div>
      <div>
        <p><b>File Name</b></p>
        <input v-model="file_name" class="outlined full_width" placeholder="שם הקובץ">
      </div>
      <div class="vertical_space"></div>
      <div v-if="!file_helper.isAuthorized(file_name)">
        <p class="m-0"><b>אנא תקנ/י את השגיאות הבאות בשם של הקובץ:</b></p>
        <p class="m-0" v-for="file_error in file_errors" :key="file_error">תו לא מקובל - "<b>{{ file_error }}</b>"</p>
      </div>
      <p v-if="file != undefined && !isFileSizeOver5KB"><b>שגיאה: הגודל של הקובץ נמוך מ- 5KB</b></p>
      <p v-if="file != undefined && !isValidFileName" class="red_text"><b>שגיאה: נא להוסיף סיומת לשם הקובץ</b></p>
      <div class="vertical_space"></div>
      <div class="vertical_space"></div>
      <div>
        <checkbox v-model="is_stamped">האם הקובץ כבר חתום?</checkbox>
      </div>
      <div class="vertical_space"></div>
      <div class="vertical_space"></div>
      <div>
        <checkbox v-if="!isFileExtensionsValid" v-model="is_sure" class="red_text">סיומת קובץ לא חוקית (WORD או PDF) - האם להמשיך ?</checkbox>
      </div>
      <div class="vertical_space"></div>
      <div class="vertical_space"></div>
      <div class="modal_footer">
        <a
          @click="submit()"
          :class="{'is-loading': is_loading, faded: !isAuthorized || !isFileSizeOver5KB || !isValidFileName || !isToSubmit}"
          class="button is-info"
          >Submit</a
        >
      </div>
    </div>
    <p v-else class="bold">הקובץ הועלה בהצלחה.</p>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import FileHelper from '@/custom/classes/file_helper.js'
import Checkbox from '@/components/Checkbox'
export default {
  name: 'upload-file-form',
  props: ['payload'],
  data () {
    return {
      is_loading: false,
      is_sent_file: false,
      file_helper: new FileHelper(),
      file: undefined,
      file_name: '',
      is_stamped: false,
      is_sure: false,
      file_errors: []
    }
  },
  watch: {
    file_name () {
      this.file_errors = this.file_helper.getErrors(this.file_name)
    }
  },
  computed: {
    isAuthorized () {
      if (this.file == undefined) {
        return false
      }
      return this.file_helper.isAuthorized(this.file_name)
    },
    isFileSizeOver5KB () {
      if (this.file == undefined) {
        return false
      }
      let file_size_kb = this.file.size / 1000
      return file_size_kb > 5
    },
    isValidFileName () {
      if (!this.file_name) return true
      if (this.file_name.split('.').length <= 1) return false
      return true
    },
    isFileExtensionsValid () {
      if (this.file == undefined && this.isValidFileName) return true
      let cv_extension = this.file_name.split('.').pop()
      return ['pdf', 'doc', 'docx'].includes(cv_extension)
    },
    isToSubmit () {
      if (!this.isFileExtensionsValid) {
        if (this.is_sure) return true
        return false
      }
      return true
    }
  },
  methods: {
    getFile (event) {
      let file = event.target.files[0]
      this.file = file
      this.file_name = file.name
    },
    submit () {
      let form_data = new FormData()
      form_data.append('file', this.file)
      form_data.append('file_name', this.file_name)
      if (this.payload.applicant) {
        form_data.append('is_stamped', this.is_stamped)
        form_data.append('resource_id', this.payload.applicant.resource_id)
        form_data.append('first_name', this.payload.applicant.first_name)
        form_data.append('last_name', this.payload.applicant.last_name)
        form_data.append('resource_type', 'Applicant')
      } else {
        form_data.append('is_contract', true)
        form_data.append('env', this.payload.company.env)
        form_data.append('env_id', this.payload.company.env_id)
      }
      this.is_loading = true
      this.$network_utils.uploadFile(form_data).then(() => {
        if (!this.payload.applicant) {
          this.onUploadConfirmed()
          return undefined
        }
        // Stamping runs asynchronously on files_server, so the file only shows up
        // in the applicant folder a moment later. Verify it actually landed
        // instead of reporting success blindly.
        return this.waitForUploadedFile().then((found) => {
          if (found) {
            this.onUploadConfirmed()
            return
          }
          this.is_loading = false
          if (this.payload.refresh) {
            this.payload.refresh()
          }
          this.$utils.emit('show_toast', { text: 'הקובץ נשלח אך עדיין לא מופיע במערכת - רענני בעוד רגע; אם לא יופיע, פני לתמיכה' })
        })
      }).catch(() => {
        this.is_loading = false
        this.$utils.emit('show_toast', { text: 'ארעה שגיאה בהעלאת הקובץ - ודאי שהקובץ תקין ושגודלו עד 10MB' })
      })
    },
    onUploadConfirmed () {
      if (this.payload.refresh) {
        this.payload.refresh()
      }
      this.is_sent_file = true
      this.is_loading = false
      this.$utils.emit('show_toast', { text: 'success' })
      this.remove(this.payload)
    },
    // Word uploads are converted to .pdf server-side, so match on the base name.
    uploadedFileBaseName () {
      let parts = this.file_name.split('.')
      if (parts.length > 1) {
        parts.pop()
      }
      return parts.join('.')
    },
    waitForUploadedFile (attempt = 0) {
      let base_name = this.uploadedFileBaseName()
      return this.$network_utils.getFiles({ resource_id: this.payload.applicant.resource_id }).then((files) => {
        let found = (files || []).some(({ name }) => name && name.indexOf(base_name) === 0)
        if (found) return true
        if (attempt >= 5) return false
        return new Promise(resolve => setTimeout(resolve, 2000)).then(() => this.waitForUploadedFile(attempt + 1))
      }).catch(() => {
        if (attempt >= 5) return false
        return new Promise(resolve => setTimeout(resolve, 2000)).then(() => this.waitForUploadedFile(attempt + 1))
      })
    },
    ...mapMutations('modals', ['remove'])
  },
  components: {
    Checkbox
  }
}
</script>
